import { useNavigate } from "react-router-dom";
import { Article } from "../../components/groups";
import { Button } from "../../components/basics/Button";
import { ButtonType } from "../../helpers/shared/buttonStyling";
import { windowScroll } from "../../helpers/shared/useNavigationEffects";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Confirmation: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    windowScroll();
  });
  const { t } = useTranslation("pages", { keyPrefix: "contractor.newContractor.confirmation" });
  return (
    <div className="container-flow flex-grow w-3/4 mt-6 lg:mt-32">
      <h2 className="font-serif font-bold text-4xl mb icon-check-circle icon-12 icon-green icon-bottom-1 after:ml-5">{t("message")}</h2>
      <Article>
        <p>{t("info")}</p>
      </Article>
      <div className="mt-8 mb-[524px]">
        <Button onClick={() => navigate("/contractor")} htmlType="button" className="px-0  md:w-auto flex-end mr-8" type={ButtonType.PRIMARY}>
          {t("button.homePage")}
        </Button>
        <Button onClick={() => navigate("/contractor")} htmlType="button" className="px-0  md:w-auto flex-end" type={ButtonType.SECONDARY}>
          {t("button.contractorListing")}
        </Button>
      </div>
    </div>
  );
};

export default Confirmation;
